"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  warn: function warn(message) {
    return typeof console !== 'undefined' && console.warn && console.warn('[redux-inputs]: ' + message);
  },
  error: function error(message) {
    return typeof console !== 'undefined' && console && console.error && console.error('[redux-inputs]: ' + message);
  }
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/redux-inputs/lib/util/log.js
// module id = 799
// module chunks = 0